import api from '../../utils/api';
import {
    GET_LIST_CUSTOMER_INTERACTIVE_STATUS,
    GET_SPECIFIC_CUSTOMER_INTERACTIVE_STATUS,
    UPDATE_SPECIFIC_CUSTOMER_INTERACTIVE_STATUS,
    CREATE_NEW_CUSTOMER_INTERACTIVE_STATUS,
    REMOVE_CUSTOMER_INTERACTIVE_STATUS,
    GET_CUSTOMER_INTERACTIVE_STATUS_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListCustomerInteractiveStatus = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/interaction-statuses', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_CUSTOMER_INTERACTIVE_STATUS, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getSpecificCustomerInteractiveStatus = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/interaction-statuses/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_CUSTOMER_INTERACTIVE_STATUS, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getCustomerInteractiveStatusActive = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/interaction-statuses/by-active', { params: filter }).then(res => {
            //console.log(res)
            dispatch({ type: GET_CUSTOMER_INTERACTIVE_STATUS_ACTIVE, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createCustomerInteractiveStatus = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/interaction-statuses', data).then(res => {
            dispatch({ type: CREATE_NEW_CUSTOMER_INTERACTIVE_STATUS, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}



export const updateCustomerInteractiveStatus = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/interaction-statuses/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_CUSTOMER_INTERACTIVE_STATUS, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeCustomerInteractiveStatus = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/interaction-statuses`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_CUSTOMER_INTERACTIVE_STATUS, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}
